import { P2GText, P2GGrid, P2GCheckBoxLegacy, P2GRadio } from '@parcel2go/core-ui';
import { SmartSendFilter, SortField, TranslateSortField } from '../../../lib/helpers/SmartSendFilterApplier';
import { P2GDropdown } from '@parcel2go/core-ui';
import { EventSections } from '../../../lib/events/EventLogger';
import { ClickType } from '../../../lib/events/ClickType';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { useAnalytics } from '@parcel2go/npm-p2g-app';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';

interface props {
  filter: SmartSendFilter;
  actions: SortField[];
  update: (filter: SmartSendFilter) => void;
  isXs: boolean;
}

export const Sort: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const isdate = props.filter.SortField == 'Date' || props.filter.SortField == 'TransactionProcessed';
  const { track } = useAnalytics();
  const onClick = (event: string, clickType: ClickType, payload?: any) => {
    track({
      type: `filter_${clickType}`.toLowerCase(),
      payload: {
        ...GenerateBaseAnalyticsPayload([EventSections.SmartSend, EventSections.QuickActions, 'filter', event]),
        action: payload
      }
    });
  };

  return (
    <>
      <P2GGrid container spacing={1} alignItems="center">
        <P2GGrid item flexShrink={1}>
          <P2GText>{t('SORT_DIRECTION', { defaultValue: 'Sort Direction' })}</P2GText>
        </P2GGrid>
        <P2GGrid item flexShrink={1}>
          <P2GRadio
            name="SortOrder"
            id="SortAsc"
            label={isdate ? t('SORT_BY_OLDEST', { defaultValue: 'Oldest' }) : t('SORT_BY_ASC', { defaultValue: 'Asc' })}
            checked={props.filter.SortOrder === 'asc'}
            onChange={() => {
              props.update({ ...props.filter, SortOrder: 'asc' });
              onClick('SortOrder', 'selected', 'asc');
            }}
            value="asc"
            disabled={props.filter.DisableSort}
          />
        </P2GGrid>
        <P2GGrid item flexShrink={1}>
          <P2GRadio
            name="SortOrder"
            id="SortDesc"
            label={
              isdate ? t('SORT_BY_NEWEST', { defaultValue: 'Newest' }) : t('SORT_BY_DESC', { defaultValue: 'Desc' })
            }
            checked={props.filter.SortOrder === 'desc'}
            onChange={() => {
              props.update({ ...props.filter, SortOrder: 'desc' });
              onClick('SortOrder', 'selected', 'desc');
            }}
            value="desc"
            disabled={props.filter.DisableSort}
          />
        </P2GGrid>
      </P2GGrid>
      <P2GDropdown
        id="Sort By"
        label={t('SORT_BY_INPUT_LABEL', { defaultValue: 'Sort' })}
        value={props.filter.SortField}
        options={props.actions.map((o) => {
          return {
            value: o,
            text: TranslateSortField(o)
          };
        })}
        onChange={(o) => {
          props.update({ ...props.filter, SortField: o as any });
          onClick('SortBy', 'selected', o);
        }}
        disabled={props.filter.DisableSort}
      />
      {!props.isXs && (
        <P2GCheckBoxLegacy
          checked={props.filter.ShowAsGroup}
          onChange={() => {
            props.update({ ...props.filter, ShowAsGroup: !props.filter.ShowAsGroup });
            onClick('Group', 'selected', !props.filter.ShowAsGroup);
          }}
          id="Group"
          label={t('ORGANISE_INTO_GROUPS_INPUT_LABEL', { defaultValue: 'Organise into groups' })}
          labelPlacement="end"
          variant="primary"
          error={false}
          disabled={props.filter.DisableSort}
        />
      )}
    </>
  );
};
export default Sort;
